export default __webpack_public_path__ + "static/media/working1.f7998554.png";